import { IIconBase } from '..'

const receiptDiscountDisabledIcon = ({
  color = '#A1A7C4',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/receipt-discount'>
        <path
          id='Vector'
          d='M14.6667 3.99992V5.61325C14.6667 6.66658 14.0001 7.33325 12.9467 7.33325H10.6667V2.67325C10.6667 1.93325 11.2734 1.33325 12.0134 1.33325C12.7401 1.33992 13.4067 1.63325 13.8867 2.11325C14.3667 2.59992 14.6667 3.26659 14.6667 3.99992Z'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M1.33325 4.66659V13.9999C1.33325 14.5533 1.95992 14.8666 2.39992 14.5333L3.53992 13.6799C3.80659 13.4799 4.17992 13.5066 4.41992 13.7466L5.52659 14.8599C5.78659 15.1199 6.21325 15.1199 6.47325 14.8599L7.59325 13.7399C7.82659 13.5066 8.19992 13.4799 8.45992 13.6799L9.59992 14.5333C10.0399 14.8599 10.6666 14.5466 10.6666 13.9999V2.66659C10.6666 1.93325 11.2666 1.33325 11.9999 1.33325H4.66659H3.99992C1.99992 1.33325 1.33325 2.52659 1.33325 3.99992V4.66659Z'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M4.17993 9.15343L7.81993 5.51343'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M7.94979 9.00008H7.95578'
          stroke={color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M4.12972 5.66659H4.13571'
          stroke={color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export default receiptDiscountDisabledIcon
